import { createFileRoute } from '@tanstack/react-router';
import { useCallback } from 'react';

import { SettingsPage, type SettingsTab } from '@/features/settings/SettingsPage';

export interface SettingsSearch {
  /** Открытая вкладка; без параметра — контактная информация. */
  tab?: SettingsTab;
}

export const Route = createFileRoute('/_app/settings')({
  validateSearch: (search: Record<string, unknown>): SettingsSearch => ({
    tab: search.tab === 'legal' || search.tab === 'maintenance' ? search.tab : undefined,
  }),
  component: SettingsRoute,
});

function SettingsRoute() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();

  const onTabChange = useCallback(
    (tab: SettingsTab) => {
      void navigate({ search: { tab: tab === 'contacts' ? undefined : tab } });
    },
    [navigate],
  );

  return <SettingsPage tab={search.tab ?? 'contacts'} onTabChange={onTabChange} />;
}
